import React, { useState } from "react";
import {
  FaHeadset,
  FaClock,
  FaTicketAlt,
  FaCreditCard,
  FaTimes,
} from "react-icons/fa";

const StickyCallCard = () => {
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;

  return (
    <div className="fixed bottom-2 left-1/2 -translate-x-1/2 w-[95%] max-w-5xl z-50 pb-safe">
      <div className="relative bg-gradient-to-br from-yellow-200 via-orange-300 to-red-200 backdrop-blur-md text-gray-900 shadow-xl rounded-2xl px-4 py-4 border border-orange-400 animate-fadeInUp">

        {/* Close button (mobile-friendly) */}
        <button
          onClick={() => setHidden(true)}
          className="absolute top-2 right-2 text-gray-700 hover:text-black sm:hidden"
        >
          <FaTimes size={18} />
        </button>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">

          {/* Left Side */}
          <div className="text-center sm:text-left w-full sm:w-1/2">
            <h3 className="text-lg font-extrabold text-orange-700">
              Let Us Help You Book!
            </h3>

            <div className="flex flex-wrap gap-2 justify-center sm:justify-start mt-3">
              <a
                href="tel:+18887112909"
                className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-full font-bold text-sm shadow-md flex items-center gap-2 hover:scale-105 transition-transform duration-300"
              >
                📞 +1-833-833-1842
              </a>
            </div>
          </div>

          {/* Right Side — Desktop Only */}
          <div className="hidden sm:grid grid-cols-2 gap-3 text-sm w-full sm:w-1/2">
            <InfoItem icon={FaHeadset} text="Expert Guidance" />
            <InfoItem icon={FaClock} text="24/7 Support" />
            <InfoItem icon={FaTicketAlt} text="Instant Tickets" />
            <InfoItem icon={FaCreditCard} text="Installment Plans" />
          </div>
        </div>
      </div>
    </div>
  );
};

/* Reusable icon block */
const InfoItem = ({ icon: Icon, text }) => (
  <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-lg shadow-sm hover:bg-orange-100 transition duration-300">
    <div className="bg-orange-100 p-2 rounded-full">
      <Icon className="text-orange-600" />
    </div>
    <span className="font-medium">{text}</span>
  </div>
);

export default StickyCallCard;
